var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-loopingsequence",style:({
		height: `${_vm.containerSize}px`,
		width: `${_vm.containerSize}px`,
	})},[_c('canvas',{ref:"canvas",attrs:{"height":_vm.canvasSize,"width":_vm.canvasSize}})])
}
var staticRenderFns = []

export { render, staticRenderFns }